/* eslint-disable indent */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import { makeStyles } from '@material-ui/styles';
import { get } from 'lodash';
import styles from './styles';
import { GenericFormFields } from '../interfaces';
import { cyrb53Hash } from 'utils/helpers';

const useStyles = makeStyles(styles);

const FormRadioGroup: React.FC<GenericFormFields> = ({
  fields,
  item,
  values,
  setFieldValue,
  changeField,
}) => {
  const classes = useStyles({ fontSize: item.fontSize });

  const checkBoolean = (value: any) =>
    value === 'true' || value === 'false' ? value === 'true' : value;

  return (
    <Grid container item alignItems="center" spacing={2}>
      {item?.label && (
        <Grid item xs="auto">
          <Typography className={classes.radioGroupHeader}>
            {item.label}
          </Typography>
        </Grid>
      )}
      <Grid item xs="auto">
        <RadioGroup
          key={item.stateKey}
          name={item.stateKey}
          value={
            fields
              ? get(fields, item.stateKey, false)
              : get(values, item.stateKey, false)
          }
          onChange={e => {
            if (typeof e.target.value)
              if (setFieldValue)
                setFieldValue(item.stateKey, checkBoolean(e.target.value));

            if (changeField)
              changeField({
                key: item.stateKey,
                value: Object(item).hasOwnProperty('id')
                  ? {
                      id: item.id,
                      value: checkBoolean(e.target.value),
                    }
                  : checkBoolean(e.target.value),
              });
          }}
          row={!item.isRadioNotRow}
        >
          {item?.radioGroupOptions?.map(child => (
            <FormControlLabel
              key={cyrb53Hash(child.label)}
              value={child.value}
              control={<Radio />}
              label={
                typeof child.label === 'string' ? (
                  <Typography className={classes.radioLabel}>
                    {child.label}
                  </Typography>
                ) : (
                  child.label
                )
              }
            />
          ))}
        </RadioGroup>
      </Grid>
    </Grid>
  );
};

export default FormRadioGroup;
